import { render, staticRenderFns } from "./LoadableContent.vue?vue&type=template&id=308a0465&scoped=true&"
import script from "./LoadableContent.vue?vue&type=script&lang=js&"
export * from "./LoadableContent.vue?vue&type=script&lang=js&"
import style0 from "./LoadableContent.vue?vue&type=style&index=0&id=308a0465&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308a0465",
  null
  
)

export default component.exports